/** * * Asynchronously loads the component for
Billing History
* */ import { lazyLoad } from "utils/loadable";
export const BillingHistory = lazyLoad(
  () => import("./index"),
  (module) => module.BillingHistory
);